import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { EventBookingEvent } from '../types/eventBooking';

type EventBookingEventResponse = EventBookingEvent;
type DefaultError = unknown;

type UseEventBookingEventParams = {
  eventId?: string;
  include?: string;
  enabled?: boolean;
};

export function useEventBookingEvent<
  TData = EventBookingEventResponse,
  TError = DefaultError,
>(
  { eventId, include, enabled = true }: UseEventBookingEventParams = {},
  options?: Omit<
    UseQueryOptions<EventBookingEventResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = ['eventBookingEvent', eventId, include];

  return useQuery<EventBookingEventResponse, TError, TData>({
    queryKey,
    enabled: enabled && !!eventId,
    queryFn: async () => {
      if (!eventId) {
        throw new Error('eventId is required to fetch an event booking event');
      }

      return service.getEventBookingEvent(eventId, {
        ...(include ? { include } : {}),
      });
    },
    ...(options as any),
  });
}
